// 导入任务，轮询
import { latentImportErrorListApi } from "@/api/taskCenter";
import { Message } from "element-ui";
export function importLoop(tid: number) {
  return new Promise((resolve, reject) => {
    const counter = 1;
    let loop: any;
    function loopRequest() {
      latentImportErrorListApi({ task_id: tid })
        .then((taskRes: any) => {
          if (taskRes.error_code === 0) {
            resolve(taskRes);
          } else if (taskRes.error_code === 21009012) {
            loopRequest();
          } else {
            Message({
              showClose: true,
              message: "导入失败",
              type: "error",
            });
            clearTimeout(loop);
            reject();
          }
        })
        .catch(() => {
          Message({
            showClose: true,
            message: "导入失败",
            type: "error",
          });
          clearTimeout(loop);
          reject();
        });
    }
    loopRequest();
  });
}
